





















import { Component, Vue, Prop } from 'vue-property-decorator';
import IMatchCarouselItem from '../models/IMatchCarouselItem';
import MatchCarouselItem from '@/shared/components/MatchCarouselItem.vue';

@Component({
    components: {
        MatchCarouselItem,
    },
})
export default class MatchCarousel extends Vue {

    @Prop() private matches!: IMatchCarouselItem[];
    private translate: number = 0;
    private visibleItems: number = 5;
    private itemWidth: number = 226;

    private handleMatchClick(competitionId: string): any {
        console.log('handleMatchClick');
        this.$emit('handleMatchClick', competitionId)
    }

    private next(): void {
        if (this.translate >= this.visibleItems * this.itemWidth * -1) {
            this.translate = this.translate - this.itemWidth;
        }
    }

    private prev(): void {
        if (this.translate <= -this.itemWidth) {
            this.translate = this.translate + this.itemWidth;
        }
    }
}
